import { Component, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-remind-overview',
  templateUrl: './remind-overview.component.html',
  styleUrls: ['./remind-overview.component.scss']
})
export class RemindOverviewComponent {

}



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/components/remind-overview/remind-overview.component.ts